import { axiosPrivate } from "./axios";

export const videogalleryByApi = async (payloadData) => {
  let res = await axiosPrivate.get("/frontend/videogallery", payloadData);
  return res.data;
};
